
  document.addEventListener("DOMContentLoaded", function () {
    // Select all autoplay videos (add a class like 'slider-video' to target them)
    const videos = document.querySelectorAll('video.slider-video');

    videos.forEach(function(video) {
      // Monitor pause event
      video.addEventListener('pause', function () {
        // Retry play if paused not manually
        setTimeout(function () {
          if (video.paused) {
            video.play().catch(function (error) {
              // Silently ignore play issues (e.g., browser restrictions)
              console.warn("Autoplay resume failed:", error);
            });
          }
        }, 300); // Slight delay to allow popup DOM changes
      });

      // Periodically check if the video has been paused and resume it
      setInterval(function () {
        if (video.paused) {
          video.play().catch(function () {});
        }
      }, 1000); // Recheck every 5 seconds
    });
  });